"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("../../../styles/colors");

var _shadows = require("../../../styles/shadows");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    align-items: center;\n    height: 100%;\n    text-shadow: ", ";\n\n    &:hover {\n        color: ", ";\n        cursor: default;\n    }\n\n    &[title] {\n        cursor: default;\n        text-decoration: none;\n    }\n\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledContent = _styledComponents["default"].span(_templateObject(), _shadows.SHADOW_1, _colors.COLOR_WHITE, function (props) {
  return props.initialsVariant === 'inverse' && "\n            background-color: ".concat(_colors.COLOR_GRAY_2, ";\n            color: ").concat(_colors.COLOR_GRAY_4, ";\n            text-shadow: none;\n        \n            &:hover {\n                color: ").concat(_colors.COLOR_GRAY_4, ";\n                cursor: default;\n            }\n        ");
});

var _default = StyledContent;
exports["default"] = _default;